// import supabase from "./supabase"; // Remove old import
import { createClient } from "@/utils/supabase/client"; // Import the client utility

// Updated Comment type to include profile information
export interface Comment {
  id: number;
  post_id: string;
  user_id: string;
  content: string;
  created_at: string;
  profiles: { 
    nickname: string;
    avatarUrl?: string;
  } | null;
}

// Fetch comments with user nicknames
export async function fetchComments(postId: string): Promise<Comment[]> {
  const supabase = createClient(); // Create client instance using utility
  const { data: commentsData, error: commentsError } = await supabase
    .from("comments")
    .select("*") // 모든 댓글 필드 선택
    .eq("post_id", postId)
    .order("created_at", { ascending: false });

  if (commentsError) {
    console.error("댓글 목록 로드 오류:", commentsError);
    return []; // 오류 시 빈 배열 반환
  }
  if (!commentsData || commentsData.length === 0) {
    return []; // 댓글 없으면 빈 배열 반환
  }

  // 2. 고유한 사용자 ID 추출
  const userIds = Array.from(new Set(commentsData.map(comment => comment.user_id)));

  if (userIds.length === 0) {
    // 모든 댓글이 user_id가 없는 경우 (이론상 발생하기 어려움)
    return commentsData.map(comment => ({ ...comment, profiles: null })) as Comment[];
  }

  // 3. 프로필 정보 조회
  const { data: profilesData, error: profilesError } = await supabase
    .from("profiles")
    .select("user_id, nickname, avatar_url") // avatar_url 추가
    .in("user_id", userIds);

  if (profilesError) {
    console.error("프로필 정보 로드 오류:", profilesError);
    return commentsData.map(comment => ({ ...comment, profiles: null })) as Comment[];
  }

  // 4. 프로필 정보를 Map으로 변환
  const profilesMap = new Map<string, { nickname: string; avatar_url: string | null }>();
  profilesData?.forEach(profile => {
    if (profile.user_id) {
      profilesMap.set(profile.user_id, {
        nickname: profile.nickname || '익명',
        avatar_url: profile.avatar_url
      });
    }
  });

  // 5. 댓글 데이터와 프로필 정보 합치기
  const commentsWithProfiles = commentsData.map(comment => {
    const profile = profilesMap.get(comment.user_id);
    return {
      ...comment,
      profiles: profile ? {
        nickname: profile.nickname,
        avatarUrl: profile.avatar_url
      } : null
    };
  });

  return commentsWithProfiles as Comment[];
}

// Client-side addComment function is removed (replaced by Server Action)
/*
export async function addComment(postId: string, userId: string, content: string): Promise<Comment | null> {
  // ... implementation removed ...
}
*/

// Client-side deleteComment function is removed (replaced by Server Action)
/*
export async function deleteComment(commentId: number, userId: string): Promise<boolean> {
  // ... implementation removed ...
}
*/
